module.exports = __webpack_public_path__ + "img/sign-up-img-2.00de5c8.png";